import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';

const client = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
    <QueryClientProvider client={client}>
     <AuthProvider >
       <RouterProvider router={router} /> 
     </AuthProvider> 
    </QueryClientProvider>
    </React.StrictMode>
);

